import * as yup from 'yup'

const schema = () =>
  yup.object().shape({
    answers: yup.array().of(
      yup.object().shape({
        answer: yup.string().required(),
        how: yup.string().required(),
        why: yup.string().required(),
      }),
    ),
  })

export default schema
